













import { Component, Vue, Watch } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import formatCustomer from '@/utils/formatCustomer';
import ProspectsList from '@/components/prescriber/ProspectsList.vue';

@Component({
    components: {
        VxBreadcrumb,
        ProspectsList,
    },
    filters: {
        formatCustomer,
    },
})
export default class Prospects extends Vue {}
